module.exports = __webpack_public_path__ + "static/img/th.7b21fcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/th.png
// module id = BOYn
// module chunks = 18